// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-page-wrapper {
  /* padding-top: 90px; */
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
  /* height: 100vh; */
}

.admin-page-header {
  display: flex;
  align-items: center;
  text-align: left;
  padding-top: 16px;
  border-bottom: 1px solid #85858545;
  padding-bottom: 16px;
}

.admin-page-header h2 {
  font-size: 38px;
  color: #383838;
  margin: 0px;
}

.admin-page-header img {
  width: 70px;
}

.admin-user-table-wrapper {
  width: 60%;
  margin: 0 auto;
  text-align: center;
  margin-top: 50px;
  border: 2px solid #F8F8F8;
  border-radius: 18px;
  padding: 40px 30px;
}

.table {
  --bs-table-bg: unset !important;
}


.admin-user-table-wrapper thead {
  background-color: #00A19B08 !important;
}


.admin-user-table-wrapper th{
  border-bottom: 0px;
}

.admin-user-table-wrapper th:first-child {
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}

.admin-user-table-wrapper th:last-child {
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;

}

.admin-user-table-wrapper table tr td{
  border: unset !important;
}

.admin-user-table-wrapper .table > tbody {
  border-left: unset;
  border-right: unset;
  border-top: unset !important;
}

/* .admin-user-table-wrapper
.table>:not(caption)>*>* {
  border-bottom-width: 0px !important;
} */`, "",{"version":3,"sources":["webpack://./src/Dashboard/Admin-user/Admin.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;;AAGA;EACE,sCAAsC;AACxC;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;;AAElC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;;;GAGG","sourcesContent":[".admin-page-wrapper {\n  /* padding-top: 90px; */\n  background-size: 100% 100% !important;\n  background-repeat: no-repeat !important;\n  /* height: 100vh; */\n}\n\n.admin-page-header {\n  display: flex;\n  align-items: center;\n  text-align: left;\n  padding-top: 16px;\n  border-bottom: 1px solid #85858545;\n  padding-bottom: 16px;\n}\n\n.admin-page-header h2 {\n  font-size: 38px;\n  color: #383838;\n  margin: 0px;\n}\n\n.admin-page-header img {\n  width: 70px;\n}\n\n.admin-user-table-wrapper {\n  width: 60%;\n  margin: 0 auto;\n  text-align: center;\n  margin-top: 50px;\n  border: 2px solid #F8F8F8;\n  border-radius: 18px;\n  padding: 40px 30px;\n}\n\n.table {\n  --bs-table-bg: unset !important;\n}\n\n\n.admin-user-table-wrapper thead {\n  background-color: #00A19B08 !important;\n}\n\n\n.admin-user-table-wrapper th{\n  border-bottom: 0px;\n}\n\n.admin-user-table-wrapper th:first-child {\n  border-top-left-radius: 15px;\n  border-bottom-left-radius: 15px;\n}\n\n.admin-user-table-wrapper th:last-child {\n  border-top-right-radius: 15px;\n  border-bottom-right-radius: 15px;\n\n}\n\n.admin-user-table-wrapper table tr td{\n  border: unset !important;\n}\n\n.admin-user-table-wrapper .table > tbody {\n  border-left: unset;\n  border-right: unset;\n  border-top: unset !important;\n}\n\n/* .admin-user-table-wrapper\n.table>:not(caption)>*>* {\n  border-bottom-width: 0px !important;\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
